import { useState } from "react";

import { ToggleButtons } from "../../../../components/ToggleButtons";
import { useModal } from "../../../../hooks/useModal";
import { IBillingRefund } from "../../../../types/billings";
import { getStringFromISOString } from "../../../../utils/dateHandler";
import { BillingRefundChangeModal } from "../BillingRefundChangeModal";

interface BillingRefundButtonsProps {
  refund: IBillingRefund;
  isDisabled?: boolean;
}

export const BillingRefundButtons = ({ refund, isDisabled = false }: BillingRefundButtonsProps) => {
  const { isModalVisible, toggleModalVisibility } = useModal();
  const [isRefundedPending, setIsRefundedPending] = useState<boolean | null>(null);
  const isRefunded = !!refund.paymentDate;

  const handleIsRefundedChange = (nextIsRefunded: boolean) => {
    if (nextIsRefunded === isRefunded) return;
    setIsRefundedPending(nextIsRefunded);
    toggleModalVisibility();
  };

  const handleModalClose = () => {
    toggleModalVisibility();
    setIsRefundedPending(null);
  };

  return (
    <>
      <ToggleButtons
        value={isRefunded}
        trueExtraText={refund.paymentDate ? getStringFromISOString(refund.paymentDate) : undefined}
        isDisabled={isDisabled}
        onChange={handleIsRefundedChange}
      />
      <BillingRefundChangeModal
        isRefunded={!!isRefundedPending}
        refund={refund}
        isModalVisible={isModalVisible}
        toggleModalVisibility={handleModalClose}
      />
    </>
  );
};
